var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup',{ref:"popup",attrs:{"show":_vm.show,"show-title-bar":false,"class-name":"actions-modal"}},[_vm._t("default"),_vm._v(" "),(_vm.showCancelButton)?_c('action-group',[_c('action-button',{staticClass:"color-gray",nativeOn:{"click":function($event){_vm.close()}}},[_vm._v("Cancel")])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-36def872","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/Actions.vue
// module id = null
// module chunks = 